import { observer } from "owa-mobx-react";
import { getSelectedNode } from "owa-mail-folder-forest-store";
import { type FolderForestNodeType } from "owa-favorites-types";
import { isSearchFolderExpired } from "owa-folders";
import { getIsSearchTableShown, getSafeSelectedTableView } from "owa-mail-list-store";
import getSelectedFolder from "owa-mail-store/lib/utils/getSelectedFolder";
import { StatusBarCounts } from "owa-status-bar";
import { getIsNonMailEntitySearchTab } from "owa-tabbed-search";
import React from "react";

export const MailStatusBarItems: React.FunctionComponent = observer(function MailStatusBarItems() {
    if (getIsSearchTableShown()) {
        if (getIsNonMailEntitySearchTab()) {
            return null;
        }
        const tableView = getSafeSelectedTableView();
        return tableView ? <StatusBarCounts items={tableView.rowKeys.length}/> : null;
    }
    
    const selectedNode = getSelectedNode();
    if (selectedNode.type !== 0 &&
        selectedNode.type !== 5) {
        return null;
    }
    
    const folder = getSelectedFolder();
    if (!folder || isSearchFolderExpired(selectedNode.id)) {
        return null;
    }
    
    return <StatusBarCounts items={folder.totalMessageCount} unread={folder.UnreadCount}/>;
}, "MailStatusBarItems");
